import React from "react";

function formatNumber(num) {
  // Add a narrow no-break space every thousands
  return num.toLocaleString("en-US").replace(/,/g, "\u202F");
}

function Observation({ o }) {
  const nbsp = "\u00A0";
  if (!o) {
    return "<p>INTERNAL ERROR! List of observations contains undefined element.</p>";
  }
  if (o.kind === "CountOf") {
    return (
      <div style={{ marginBottom: "1em" }}>
        <div
          className='count-area'
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.05)",
            borderRadius: "4px",
            padding: "0px",
          }}
        >
          <div
            className='count-bar'
            data-tooltip={`${o.count} of ${o.maxCount} ${o.measure} (${
              Math.round((o.count / o.maxCount) * 1000) / 10
            }%)`}
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.16)",
              borderRadius: "4px",
              paddingTop: "4px",
              paddingBottom: "4px",
              width: (o.count / o.maxCount) * 100 + "%",
            }}
          >
            <div className='count-label'>
              {formatNumber(o.count)}
              {nbsp}/{nbsp}
              {formatNumber(o.maxCount)}
            </div>
          </div>
        </div>
        <div
          className='count-caption'
          style={{
            fontWeight: 700,
            textAlign: "center",
            marginTop: ".2em",
          }}
        >
          {o.measure}
        </div>
      </div>
    );
  } else if (o.kind === "Categorical") {
    return (
      <div style={{ marginBottom: "1em" }}>
        <div
          className='category-area'
          data-tooltip={o.categoryDescription}
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.05)",
            borderRadius: "4px",
            padding: "4px",
          }}
        >
          <strong>{o.measure}</strong>: <span>{o.category}</span>
        </div>
      </div>
    );
  } else if (o.kind === "Percentage") {
    return (
      <div style={{ marginBottom: "1em" }}>
        <div
          className='percent-area'
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.05)",
            borderRadius: "4px",
            padding: "0px",
          }}
        >
          <div
            className='percent-bar'
            data-tooltip={`${o.percent} % ${o.measure}`}
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.16)",
              borderRadius: "4px",
              paddingTop: "4px",
              paddingBottom: "4px",
              width: o.percent + "%",
            }}
          >
            <div className='percent-label'>
              {o.percent}
              {nbsp}%
            </div>
          </div>
        </div>
        <div
          className='percent-caption'
          style={{
            fontWeight: 700,
            textAlign: "center",
            marginTop: ".2em",
          }}
        >
          {o.measure}
        </div>
      </div>
    );
  } else if (o.kind === "Scale") {
    const mxLabel = o.maxLabel.replace(/\s/g, nbsp);
    const mnLabel = o.minLabel.replace(/\s/g, nbsp);
    const percent = ((o.value - o.minValue) / (o.maxValue - o.minValue)) * 100;
    return (
      <div style={{ marginBottom: "1em" }}>
        <div
          className='scale-area'
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.05)",
            borderRadius: "4px",
            padding: "0px",
          }}
        >
          <div
            className='scale-bar'
            data-tooltip={`${o.value} (${Math.round(
              percent
            )}%) on a scale from ${o.minValue} (${mnLabel}) to ${
              o.maxValue
            } (${mxLabel})`}
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.16)",
              borderRadius: "4px",
              paddingTop: "4px",
              paddingBottom: "4px",
              width: percent + "%",
            }}
          >
            <div
              className='scale-label'
              style={{ width: 10000 / percent + "%" }}
            >
              <table style={{ width: "100%" }}>
                <tr>
                  <td style={{ width: "40%" }}>
                    {mnLabel}
                    <br />
                    &larr;{o.minValue}
                  </td>
                  <td style={{ width: "20%", textAlign: "center" }}>
                    &nbsp;
                    <br />
                    {o.value}
                  </td>
                  <td style={{ width: "40%", textAlign: "right" }}>
                    {mxLabel}
                    <br />
                    {o.maxValue}&rarr;
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div
          className='scale-caption'
          style={{
            fontWeight: 700,
            textAlign: "center",
            marginTop: ".2em",
          }}
        >
          {o.measure}
        </div>
      </div>
    );
  } else if (o.kind === "Likert") {
    const totalCount = o.counts.reduce((sum, current) => sum + current, 0);
    const bars = [];
    for (let i = 0; i < o.counts.length; i++) {
      const count = o.counts[i];
      const levelLabel = o.levelLabels[i];
      const nbLevelLabel = levelLabel.replace(/\s/g, nbsp);
      const bar = (
        <div
          className='likert-bar'
          key={levelLabel}
          data-tooltip={`${count} of ${totalCount} ${levelLabel}`}
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.16)",
            borderRadius: "4px",
            paddingTop: "4px",
            paddingBottom: "4px",
            width: (100 * count) / totalCount + "%",
          }}
        >
          <div className='likert-label'>
            {nbLevelLabel}:{nbsp}
            {count}
          </div>
        </div>
      );
      bars.push(bar);
    }
    return (
      <div style={{ marginBottom: "1em" }}>
        <div
          className='likert-area'
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.05)",
            borderRadius: "4px",
            padding: "0px",
          }}
        >
          {bars}
        </div>
        <div
          className='likert-caption'
          style={{
            fontWeight: 700,
            textAlign: "center",
            marginTop: ".2em",
          }}
        >
          {o.measure}
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default Observation;
